'use strict';

var React = require('react');

var SvgFraudProtectMajor = function SvgFraudProtectMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.093 2.915a1.75 1.75 0 0 0-2.186 0l-.317.253a15.25 15.25 0 0 1-3.217 1.976l-.847.384a1.71 1.71 0 0 0-1.01 1.628c.166 3.719 1.692 6.229 3.191 7.805a11.209 11.209 0 0 0 2.035 1.692 8.9 8.9 0 0 0 .874.496l.058.027.017.008.006.003h.002s.002.001.301-.686l-.299.687a.75.75 0 0 0 .599-1.375l-.005-.002a2.582 2.582 0 0 1-.18-.09 7.378 7.378 0 0 1-.56-.329 9.71 9.71 0 0 1-1.76-1.464c-1.29-1.357-2.633-3.536-2.781-6.84-.003-.067.037-.15.133-.194l.846-.385a16.75 16.75 0 0 0 3.534-2.17l.317-.253a.25.25 0 0 1 .312 0l.354.283a16.75 16.75 0 0 0 3.445 2.129l.9.415c.095.045.134.128.131.194a12.111 12.111 0 0 1-.203 1.752.75.75 0 1 0 1.473.284c.118-.617.198-1.272.229-1.97a1.709 1.709 0 0 0-1.002-1.621l-.9-.416a15.249 15.249 0 0 1-3.136-1.938l-.354-.283Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.018 14.75h-.036a2.768 2.768 0 0 0-2.454 1.488.692.692 0 0 0 .614 1.012h3.716c.52 0 .854-.551.614-1.012a2.768 2.768 0 0 0-2.455-1.487Z"
  }));
};
SvgFraudProtectMajor.displayName = "FraudProtectMajor";

exports.SvgFraudProtectMajor = SvgFraudProtectMajor;
